import React from 'react';
import { Button } from 'react-bootstrap';
import { Check2, X } from 'react-bootstrap-icons';
export default (props) => {
    const entryPoint = props.entryPoint;
    const handleJobOutputEntry = (e) => {
        props.handleEntryPoint(props);
    }
    
    return(
        props.data[entryPoint] ? 
        <Button name="resultEntryPoint" kind = "ghost" label="fileNotSelected" onClick={e => handleJobOutputEntry(e)}><X/> </Button> : <Button className = "selectedFile" label="fileSelected" name="resultEntryPoint" kind = "ghost" onClick={e => handleJobOutputEntry(e)}>
            <Check2/>
        </Button>
    )
};